import { useAtomValue, useSetAtom } from 'jotai';
import React, { useEffect, useState } from 'react';
import { useQuery } from 'react-query';

import { Box } from '@mui/material';

import {
  isAuthenticatedAtom,
  locationsAtom,
  navbarHeightAtom,
  selectedStateAtom,
} from '../utils/AtomConfig';
import Constants from '../utils/Constants';
import { SharePointService } from '../utils/SharePointService';
import { AccessRestricted } from './AccessRestricted';
import { GenericError } from './GenericError';
import { SiteSelector } from './SiteSelector';
import { StateSelector } from './StateSelector';

export function Home() {
  const setLocations = useSetAtom(locationsAtom);
  const selectedState = useAtomValue(selectedStateAtom);
  const isAuthenticated = useAtomValue(isAuthenticatedAtom);
  const navbarHeight = useAtomValue(navbarHeightAtom);

  const [hasNoAccess, setHasNoAccess] = useState(false);
  const [hasGenericError, setHasGenericError] = useState(false);

  const sharepointService = SharePointService.Instance;
  const locationsQuery = useQuery(
    Constants.QUERY_KEYS.LOCATIONS,
    () => sharepointService.getLocations(),
    {
      ...Constants.BASE_DISABLE_REFETCH_SETTINGS,
      enabled: isAuthenticated,
      onError: (error: any) => {
        if (error.response && error.response.status === 403) {
          setHasNoAccess(true);
        } else {
          setHasGenericError(true);
        }
      },
    }
  );

  useEffect(() => {
    if (locationsQuery.data) {
      setLocations(locationsQuery.data);
    }
  }, [locationsQuery.data, setLocations]);

  const isLoading = locationsQuery.isLoading || locationsQuery.isIdle;

  if (hasNoAccess) {
    return <AccessRestricted />;
  }

  if (hasGenericError) {
    return <GenericError />;
  }

  return (
    <Box
      sx={{
        backgroundColor: '#ECECF7',
        paddingLeft: {
          xs: 2,
          sm: 4,
        },
        paddingRight: {
          xs: 2,
          sm: 4,
        },
        paddingBottom: {
          xs: 2,
          sm: 4,
        },
        paddingTop: `${navbarHeight}px`,
        minHeight: `100vh`,
      }}
    >
      {selectedState ? (
        <SiteSelector />
      ) : (
        <StateSelector
          isLoading={isLoading}
        />
      )}
    </Box>
  );
}
